<template>
  <div class="headBarBox">
    <div class="publicContent">
      <div class="autoPublicContent" v-if="isPC">
        <div class="headBarCont">
          <div class="logo"><img v-if="pageDataArr" :alt="pageDataArr[19].home_image_title"
              :src="pageDataArr[19].home_image_picture" @click="$router.push('/')"></div>
          <div class="right">
            <div class="navBtnBox">
              <div class="nav" v-for="(item, index) in menuAll" :key="index">
                <!-- 2025-11-13 改成没有子目录 -->
                <span class="el-dropdown-link" @click="$router.push(item.category_path)"
                  :class="$route.path == item.category_path + '' ? 'ac' : ''">{{
                    item.category_name }}</span>

                <!-- <span v-if="!item.children || item.category_component === '/ContactPage'" class="el-dropdown-link"
                  @click="$router.push(item.category_path)">{{
                    item.category_name }}</span>

                <el-dropdown v-if="item.children && item.category_component !== '/ContactPage'">
                  <span class="el-dropdown-link" @click="$router.push(item.category_path)">{{ item.category_name
                  }}</span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item2, index2) in item.children" :key="index2"><router-link
                        :to="item2.category_path">{{ item2.category_name }}</router-link></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->
              </div>
            </div>
            <div class="langSwitch">
              <el-dropdown>
                <span class="el-dropdown-link">
                  <svg t="1706673870929" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="4112" width="20" height="20">
                    <path
                      d="M951.856 326.93546667c-24.016-56.77866667-58.39146667-107.76746667-102.17386667-151.55093334-43.78346667-43.7824-94.77333333-78.16-151.55093333-102.17493333C639.33546667 48.3424 576.89173333 35.73333333 512.53333333 35.73333333c-64.35946667 0-126.8032 12.60906667-185.59786666 37.47626667-56.77866667 24.01493333-107.76746667 58.39253333-151.55093334 102.17493333s-78.16 94.7712-102.17493333 151.55093334C48.34133333 385.73013333 35.73333333 448.17386667 35.73333333 512.53333333s12.60906667 126.8032 37.47626667 185.59786667c24.01493333 56.77866667 58.39253333 107.76746667 102.17493333 151.55093333 43.7824 43.7824 94.7712 78.15893333 151.55093334 102.17386667C385.72906667 976.72426667 448.17386667 989.33333333 512.53333333 989.33333333c64.3584 0 126.80213333-12.60906667 185.59893334-37.47733333 56.7776-24.01493333 107.76746667-58.39146667 151.55093333-102.17386667 43.7824-43.78346667 78.15786667-94.77226667 102.17386667-151.55093333C976.7232 639.33653333 989.33333333 576.8928 989.33333333 512.53333333s-12.61013333-126.8032-37.47733333-185.59786666zM954.05226667 496H811.68746667c-2.92586667-77.86666667-22.9024-154.28373333-58.44586667-223.0912 30.6528-15.776 59.696-34.30826667 86.86826667-55.904C907.45173333 291.40053333 949.872 388.26666667 954.05226667 496zM530.13333333 86.99093333c73.6 41.9744 132.18133333 100.5696 174.512 169.61706667C649.6608 279.95413333 590.93333333 293.30453333 530.13333333 295.5968V86.99093333z m-34.13333333 208.70186667c-62.93333333-2.064-124.192-16.07786667-181.09333333-40.83733333C358.65386667 184.16426667 419.2 124.53866667 496 82.65386667v213.03893333z m-169.44533333 1.88906667C380.6912 317.80906667 437.33333333 328.90666667 496 330.64853333V496H240.67093333c2.97173333-74.66666667 22.688-146.32213333 56.06186667-210.05653333 9.72373333 4.31893333 19.81653333 7.9008 29.82186667 11.6384zM496 530.13333333v160.1888c-58.66666667 1.74826667-115.7984 12.9344-170.14613333 33.328a536.71893333 536.71893333 0 0 0-33.03253334 13.65653334C261.08693333 674.0512 242.66346667 603.73333333 240.49173333 530.13333333H496z m0 195.1456v222.28693334c-78.93333333-43.32373333-141.61386667-105.5968-185.5776-179.48266667C368.56533333 742.09386667 430.93333333 727.39413333 496 725.27893333z m34.13333333 0.09386667c61.86666667 2.35413333 122.7456 16.36906667 178.98453334 40.90453333C666.55146667 838.51946667 605.86666667 899.76853333 530.13333333 943.2288v-217.856z m167.984-1.3856C644.28693333 703.6736 587.73333333 692.40213333 530.13333333 690.4V530.13333333h246.76693334c-2.1504 73.6-19.9808 142.5248-51.1392 205.29706667-9.10506667-4.03626667-18.29013333-7.9136-27.64373334-11.4432zM530.13333333 496V330.57066667c57.6-1.9936 113.664-13.17653333 167.2864-33.3248 8.26453333-3.10613333 16.39253333-5.96693333 24.46613334-9.4688C754.67306667 351.04426667 773.7792 421.33333333 776.72106667 496H530.13333333z m285.39626667-304.7872a492.79146667 492.79146667 0 0 1-79.3984 50.63786667 504.32 504.32 0 0 0-3.7792-6.18666667 531.2928 531.2928 0 0 0-154.90666667-160.22826667c91.42506667 13.51786667 173.81546667 55.14026667 238.08426667 115.77706667zM437.57226667 77.04106667a531.30453333 531.30453333 0 0 0-152.53226667 158.62293333c-0.85973333 1.38026667-1.696 2.77333333-2.54293333 4.16106667a492.81706667 492.81706667 0 0 1-74.10453334-47.536c62.07893333-58.9856 141.23093333-100.1568 229.17973334-115.248z m-253.66506667 140.896c25.54773333 20.1568 52.72746667 38.06613333 81.33333333 53.10613333C229.0144 340.40426667 208.6624 417.06666667 205.70666667 496H71.0144c4.15786667-106.66666667 46.16106667-203.81546667 112.8928-278.06293333zM71.0144 530.13333333h134.5312c2.17173333 77.86666667 21.3088 153.5808 55.97333333 222.5344-28.04586667 15.03466667-54.69333333 32.65066667-79.75573333 52.63466667C116.27413333 731.37066667 75.12853333 635.73333333 71.0144 530.13333333z m135.02826667 300.3872a492.68906667 492.68906667 0 0 1 72.25066666-47.1552 525.08373333 525.08373333 0 0 0 7.37173334 12.1728 531.24373333 531.24373333 0 0 0 141.87946666 150.64746667c-85.0432-16.63466667-161.42933333-57.74186667-221.50186666-115.66506667z m381.12106666 117.56266667a531.30026667 531.30026667 0 0 0 144.56426667-152.54506667 524.3904 524.3904 0 0 0 8.5984-14.2528 492.8832 492.8832 0 0 1 77.56266667 50.33066667c-62.33813333 59.68-142.06826667 101.32373333-230.72533334 116.4672z m255.088-141.63626667a527.3408 527.3408 0 0 0-85.3088-55.89226666C790.93333333 682.1728 809.69813333 608 811.84746667 530.13333333h142.20373333c-4.13546667 106.66666667-45.70026667 202.22613333-111.79946667 276.3136z"
                      p-id="4113" fill="#515151"></path>
                  </svg>
                  <div class="text clearfloat">
                    <span>{{ langSwitchVal }}</span>
                    <i class="el-icon-caret-bottom el-icon--right"></i>
                  </div>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="setLang('zh')">中文</el-dropdown-item>
                  <el-dropdown-item @click.native="setLang('us')">English</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div class="mBox" v-else>
        <div class="mHeader">
          <div class="mTop">
            <img v-if="pageDataArr" @click="$router.push('/')" :alt="pageDataArr[19].home_image_title"
              :src="pageDataArr[19].home_image_picture">
            <button @click="showMenu()"><i class="el-icon-s-fold"></i></button>
          </div>
          <transition name="mMenuDH">
            <div class="mMenu" v-show="isShowMMenu">
              <!-- <div class="mMenuBox" v-if="menuAll.length > 0" :class="$route.path == '/home'?'p-active':''" @click="$router.push('/home');showMenu()">
                <span class="mTitle">Home</span></div> -->
              <div class="mMenuBox" v-for="(item, index) in menuAll" :key="index"
                :class="$route.path == item.category_path + '' ? 'p-active' : ''" @click="showSubMMenu(index)">
                <span class="mTitle" @click="toPage(item)">{{ item.category_name }}</span>
                <!-- <transition name="subMenuDH">
                  <ul class="subMenu" v-show="isShowMSubMenu == index">
                    <li @click="toPage(item)">{{ item.category_name }}</li>
                    <li v-for="(subItem, subIndex) in item.children" :key="subIndex" @click="toPage(subItem)">
                      {{ subItem.category_name }}</li>
                  </ul>
                </transition> -->
              </div>

              <div class="mMenuBox" @click="showSubMMenu(menuAll.length)">
                <span class="mTitle"><svg style="margin-right: 8px;" t="1706673870929" class="icon"
                    viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4112" width="20"
                    height="20">
                    <path
                      d="M951.856 326.93546667c-24.016-56.77866667-58.39146667-107.76746667-102.17386667-151.55093334-43.78346667-43.7824-94.77333333-78.16-151.55093333-102.17493333C639.33546667 48.3424 576.89173333 35.73333333 512.53333333 35.73333333c-64.35946667 0-126.8032 12.60906667-185.59786666 37.47626667-56.77866667 24.01493333-107.76746667 58.39253333-151.55093334 102.17493333s-78.16 94.7712-102.17493333 151.55093334C48.34133333 385.73013333 35.73333333 448.17386667 35.73333333 512.53333333s12.60906667 126.8032 37.47626667 185.59786667c24.01493333 56.77866667 58.39253333 107.76746667 102.17493333 151.55093333 43.7824 43.7824 94.7712 78.15893333 151.55093334 102.17386667C385.72906667 976.72426667 448.17386667 989.33333333 512.53333333 989.33333333c64.3584 0 126.80213333-12.60906667 185.59893334-37.47733333 56.7776-24.01493333 107.76746667-58.39146667 151.55093333-102.17386667 43.7824-43.78346667 78.15786667-94.77226667 102.17386667-151.55093333C976.7232 639.33653333 989.33333333 576.8928 989.33333333 512.53333333s-12.61013333-126.8032-37.47733333-185.59786666zM954.05226667 496H811.68746667c-2.92586667-77.86666667-22.9024-154.28373333-58.44586667-223.0912 30.6528-15.776 59.696-34.30826667 86.86826667-55.904C907.45173333 291.40053333 949.872 388.26666667 954.05226667 496zM530.13333333 86.99093333c73.6 41.9744 132.18133333 100.5696 174.512 169.61706667C649.6608 279.95413333 590.93333333 293.30453333 530.13333333 295.5968V86.99093333z m-34.13333333 208.70186667c-62.93333333-2.064-124.192-16.07786667-181.09333333-40.83733333C358.65386667 184.16426667 419.2 124.53866667 496 82.65386667v213.03893333z m-169.44533333 1.88906667C380.6912 317.80906667 437.33333333 328.90666667 496 330.64853333V496H240.67093333c2.97173333-74.66666667 22.688-146.32213333 56.06186667-210.05653333 9.72373333 4.31893333 19.81653333 7.9008 29.82186667 11.6384zM496 530.13333333v160.1888c-58.66666667 1.74826667-115.7984 12.9344-170.14613333 33.328a536.71893333 536.71893333 0 0 0-33.03253334 13.65653334C261.08693333 674.0512 242.66346667 603.73333333 240.49173333 530.13333333H496z m0 195.1456v222.28693334c-78.93333333-43.32373333-141.61386667-105.5968-185.5776-179.48266667C368.56533333 742.09386667 430.93333333 727.39413333 496 725.27893333z m34.13333333 0.09386667c61.86666667 2.35413333 122.7456 16.36906667 178.98453334 40.90453333C666.55146667 838.51946667 605.86666667 899.76853333 530.13333333 943.2288v-217.856z m167.984-1.3856C644.28693333 703.6736 587.73333333 692.40213333 530.13333333 690.4V530.13333333h246.76693334c-2.1504 73.6-19.9808 142.5248-51.1392 205.29706667-9.10506667-4.03626667-18.29013333-7.9136-27.64373334-11.4432zM530.13333333 496V330.57066667c57.6-1.9936 113.664-13.17653333 167.2864-33.3248 8.26453333-3.10613333 16.39253333-5.96693333 24.46613334-9.4688C754.67306667 351.04426667 773.7792 421.33333333 776.72106667 496H530.13333333z m285.39626667-304.7872a492.79146667 492.79146667 0 0 1-79.3984 50.63786667 504.32 504.32 0 0 0-3.7792-6.18666667 531.2928 531.2928 0 0 0-154.90666667-160.22826667c91.42506667 13.51786667 173.81546667 55.14026667 238.08426667 115.77706667zM437.57226667 77.04106667a531.30453333 531.30453333 0 0 0-152.53226667 158.62293333c-0.85973333 1.38026667-1.696 2.77333333-2.54293333 4.16106667a492.81706667 492.81706667 0 0 1-74.10453334-47.536c62.07893333-58.9856 141.23093333-100.1568 229.17973334-115.248z m-253.66506667 140.896c25.54773333 20.1568 52.72746667 38.06613333 81.33333333 53.10613333C229.0144 340.40426667 208.6624 417.06666667 205.70666667 496H71.0144c4.15786667-106.66666667 46.16106667-203.81546667 112.8928-278.06293333zM71.0144 530.13333333h134.5312c2.17173333 77.86666667 21.3088 153.5808 55.97333333 222.5344-28.04586667 15.03466667-54.69333333 32.65066667-79.75573333 52.63466667C116.27413333 731.37066667 75.12853333 635.73333333 71.0144 530.13333333z m135.02826667 300.3872a492.68906667 492.68906667 0 0 1 72.25066666-47.1552 525.08373333 525.08373333 0 0 0 7.37173334 12.1728 531.24373333 531.24373333 0 0 0 141.87946666 150.64746667c-85.0432-16.63466667-161.42933333-57.74186667-221.50186666-115.66506667z m381.12106666 117.56266667a531.30026667 531.30026667 0 0 0 144.56426667-152.54506667 524.3904 524.3904 0 0 0 8.5984-14.2528 492.8832 492.8832 0 0 1 77.56266667 50.33066667c-62.33813333 59.68-142.06826667 101.32373333-230.72533334 116.4672z m255.088-141.63626667a527.3408 527.3408 0 0 0-85.3088-55.89226666C790.93333333 682.1728 809.69813333 608 811.84746667 530.13333333h142.20373333c-4.13546667 106.66666667-45.70026667 202.22613333-111.79946667 276.3136z"
                      p-id="4113" fill="#515151"></path>
                  </svg>{{ langSwitchVal }}</span>
                <transition name="subMenuDH">
                  <ul class="subMenu" v-show="isShowMSubMenu == menuAll.length">
                    <li @click="setLang('zh')">中文</li>
                    <li @click="setLang('us')">English</li>
                  </ul>
                </transition>
              </div>
            </div>
          </transition>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
// import {mapState} from "vuex"
export default {
  name: 'HeadBar',
  props: {
    // isPC: Boolean,
    pageData: Object,
    getPageData: Function
  },
  computed: {
    // ...mapState(['menuAll']),
  },
  data() {
    return {
      isPC: this.$commonFn.isPC(),
      menuAll: this.$store.state.menuAll,
      langSwitchVal: '中文',
      isShowMMenu: false,
      isShowMSubMenu: this.closeSubMenu,
      closeSubMenu: 999,
      pageDataArr: [],
      // pageDataObj: {
      //   site_setup_maintitle: '',
      //   site_setup_album_all: [require(`${'../assets/images/logo.png'}`)]
      // }
    }
  },
  created() {
    this.pageDataArr = this.pageData.home_image_all
    const pageLang = window.localStorage.getItem('Lang') || 'zh'
    switch (pageLang) {
      case 'zh':
        this.langSwitchVal = '中文'
        break;
      case 'us':
        this.langSwitchVal = 'English'
        break;
    }

  },
  methods: {

    toPage(item) {
      //收起mMenu和subMMenu
      this.isShowMMenu = false
      // this.isShowMSubMenu = this.closeSubMenu
      this.$router.push({
        name: item.category_label,
        // query: {
        //   id: item.category_id
        // }
      });
    },
    setLang(Lang) {
      switch (Lang) {
        case 'zh':
          this.langSwitchVal = '中文'
          break;
        case 'us':
          this.langSwitchVal = 'English'
          break;
      }
      window.localStorage.setItem('Lang', Lang)
      this.$store.dispatch('initMenu')
      this.$store.commit('setLang', Lang)
      this.$parent.getPageData()
      this.showMenu()
    },
    //手机端--menu下拉
    showMenu() {
      this.isShowMMenu = !this.isShowMMenu
      this.isShowMSubMenu = this.closeSubMenu
    },
    //手机端--subMenu下拉
    showSubMMenu(index) {
      if (this.isShowMSubMenu == index) {
        this.isShowMSubMenu = this.closeSubMenu
        return false
      }
      this.isShowMSubMenu = index
    },
  },
  watch: {
    pageData(newValue) {
      // this.pageDataObj = newValue[12]
      this.pageData = newValue
      this.pageDataArr = newValue.home_image_all
    },
    '$store.state.menuAll'(newValue) {
      this.menuAll = newValue
    },
  }
}
</script>
<style lang="scss" scoped>
.headBarBox {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0 2px 5px #ccc;
  z-index: 99;

  .headBarCont {
    width: 100%;
    height: 72px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .logo {
      height: 50px;
      cursor: pointer;

      img {
        height: 50px;
      }
    }

    .right {
      display: flex;
      flex-direction: row;
      align-items: center;

      .navBtnBox {
        display: flex;
        flex-direction: row;

        .nav {
          cursor: pointer;
          font-size: 18px;
          color: #515151;
          position: relative;
          height: 54px;
          line-height: 58px;

          span.el-dropdown-link {
            font-size: 19px;
            margin: 0 12px;
          }

          span:hover,
          .ac {
            border-bottom: 4px solid #1aa0cf;
          }
        }


      }

      .langSwitch {
        margin-left: 20px;

        .text {
          margin-left: 6px;

          span {
            background-color: #d0d0d0;
            float: left;
            margin: 0;
            padding: 0 5px;
            height: 19px;
            line-height: 19px;
          }

          i {
            line-height: 19px;
            height: 19px;
            float: left;
            background-color: #747474;
            color: #fff;
            margin: 0;
            font-size: 12px;
            padding: 0 3px;
          }
        }
      }

      .langSwitch,
      .el-dropdown,
      .el-dropdown-link {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;

        span {
          margin: 0 5px;
        }
      }
    }
  }


  // 手机版样式
  .mBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    background-color: #fff;
    border-bottom: 1px solid #ccc;

    .mTop {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1rem;
      height: 5rem;

      img {
        max-height: 2.6rem;
      }

      button {
        width: 2rem;
        height: 2rem;
        padding: 0;
        margin: 0;
        background-color: #a90303;
        border: none;
        outline: none;

        i {
          font-size: 1.6rem;
          color: #fff;
        }
      }

      button:active {
        border: 1px solid #abc7d1;
        background-color: #a90303;

      }
    }

    .mMenu {
      width: 100%;
      font-size: 1.3rem;
      background-color: #fff;
      box-shadow: 0 2px 5px #ccc;

      div {
        font-size: 1.3rem;
      }

      .mMenuBox {
        font-size: 1.3rem;
        border-top: 1px solid #ccc;
        text-align: left;

        .mTitle {
          display: flex;
          padding: 1.2rem;
          align-items: center;
        }

        .subMenu {
          border-top: 1px solid #ccc;
          padding: 1rem 2rem;
          overflow: hidden;

          // display: none;
          li {
            font-size: 1.2rem;
            padding: 0.6rem 0;

          }
        }
      }

    }

    .p-active {
      border-left: 4px solid #a90303;
    }
  }
}

.el-dropdown-menu {
  border-top: 4px solid #a90303;
  top: 55px !important;

  .popper__arrow {
    display: none !important;
  }

  li {
    text-align: center;
  }
}


.mMenuDH-enter-active {
  animation: expand-contract 0.5s ease;
}

.mMenuDH-leave-active {
  animation: expand-contract 0.3s ease-out reverse;
}

.subMenuDH-enter-active {
  animation: expand-contract 0.5s ease;
}

.subMenuDH-leave-active {
  animation: expand-contract 0.3s ease-out reverse;
}

// 收缩展开动画
@keyframes expand-contract {

  0% {
    overflow: hidden;
    opacity: 0;
    max-height: 0;
  }

  25% {
    overflow: hidden;
    opacity: 0.6;
  }

  50% {
    overflow: hidden;
    opacity: 0.8;
  }

  100% {
    max-height: 400px; // 大于等于下拉菜单的高度
    opacity: 1;
  }
}
</style>
<style lang="scss">
// .headBarBox {
//   .headBarCont {
//     .el-dropdown {
//       display: flex;
//       flex-direction: row;
//       align-items: center;
//     }
//   }
// }
.el-dropdown-menu {
  .el-dropdown-menu__item:hover {
    background-color: #fff5f5 !important;
    color: #a90303 !important;
  }

  .popper__arrow {
    display: none !important;
  }

  a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>